import {AppState} from "../store";

export const getPipelineInsightsFilter = (state: AppState) => state.pipelineInsights.filter
